let transform = require('node-json-transform').transform;

export function attributeMapper(data: any) {
  console.log(data);

  var map = {
    item: {
      agentNames: 'agentNames',
      attachments: 'attachments',
      attributeClassification: 'attributeClassification',
      attributeDSDIds: 'attributeDSDIds',
      attributeType: 'attributeType',
      changeUnitDSDIds: 'changeUnitDSDIds',
      constraints: 'constraints',
      dsdId: 'id',
      editable: 'editable',
      entitiesDSDIds: 'entitiesDSDIds',
      id: 'dsdId',
      indexedOntology: 'indexedOntology',
      isInPotentiality: 'isInPotentiality',
      isNameUpdated: 'isNameUpdated',
      isReserved: 'isReserved',
      keywords: 'keywords',
      maxAge: 'maxAge',
      minAge: 'minAge',
      name: 'name',
      nslAttributeProperties: 'nslAttributeProperties',
      ontology: 'ontology',
      ownerId: 'ownerId',
      solutionDSDIds: 'solutionDSDIds',
      solutionType: 'solutionType',
      source: 'source',
      status: 'status',
      tenant: 'tenant',
      triggerConditionalPotentiality: 'triggerConditionalPotentiality',
    },
  };
  return transform(data, map);
}
